import { EmbedsFrame, TopNav } from '@debbie/iris/dist/components/index.js'
import React from 'react'
import { useParams } from 'react-router-dom'

const EmbedsPage = (props: { context?: object }) => {
  const { id } = useParams<{ id: string }>()

  return (
    <div>
      <TopNav />
      <EmbedsFrame id={id} context={props.context} />
    </div>
  )
}

export default EmbedsPage
